// @ts-strict-ignore
import React from "react"
import { Radio, RadioOption } from "@node-space/ui-components"
import { FiatSendFormData } from "../../form/fiatSendFormSchema"
import { useTranslation } from "react-i18next"
import { UseFormSetValue } from "react-hook-form"

interface PaymentMethodGroupProps {
  formValues: FiatSendFormData
  paymentMethodOptions: RadioOption[]
  error?: string
  setValue: UseFormSetValue<FiatSendFormData>
}

export const PaymentMethodGroup = ({ formValues, paymentMethodOptions, error, setValue }: PaymentMethodGroupProps) => {
  const { t } = useTranslation()

  const handlePaymentMethodChange = (value: string) => {
    setValue('paymentMethod', value)
    setValue('achSameDay', false)
  }

  return (
    <Radio
      name="paymentMethod"
      border={false}
      key={formValues?.paymentMethod}
      testId="payment-method-selection"
      options={paymentMethodOptions}
      value={formValues?.paymentMethod}
      error={error}
      onChange={handlePaymentMethodChange}
      label={t('paymentMethod')}
    />
  )
}